// Below this length a clip gets a tenths digit. Whole seconds leave a sub-second
// clip reading 0:00 for its entire run - the AI providers ship run cycles as
// short as 0.83s - and give a few-second clip too few steps to read as a timer
// at all.
const TENTHS_BELOW_SECONDS = 10

/**
 * Formats a playback position as m:ss, or m:ss.d when the clip it belongs to is
 * shorter than TENTHS_BELOW_SECONDS. Both labels of a player pass the same
 * clipDuration, so the position and the total can never disagree on precision.
 *
 * Truncates rather than rounds so the label never reads ahead of the clip, and
 * floors negative or non-finite input to 0 so a mid-seek value can never render
 * as NaN:NaN.
 *
 * @param {number} seconds - Playback position in seconds
 * @param {number} [clipDuration=0] - Length of the clip being labelled; 0 keeps whole seconds
 * @returns {string}
 */
export const formatPlaybackTime = (seconds, clipDuration = 0) => {
  const position = Number.isFinite(seconds) && seconds > 0 ? seconds : 0
  const showsTenths = Number.isFinite(clipDuration)
    && clipDuration > 0
    && clipDuration < TENTHS_BELOW_SECONDS
  const minutes = Math.floor(position / 60)
  const remainder = position - minutes * 60
  const secondsLabel = showsTenths
    ? (Math.floor(remainder * 10) / 10).toFixed(1).padStart(4, '0')
    : String(Math.floor(remainder)).padStart(2, '0')

  return `${minutes}:${secondsLabel}`
}
